document.addEventListener("DOMContentLoaded", function () {
  let formId = "create_customer";

  document.getElementsByName("customer[first_name]")[0].value = getSavedValue("customer[first_name]");
  document.getElementsByName("customer[last_name]")[0].value = getSavedValue("customer[last_name]");
  document.getElementsByName("customer[email]")[0].value = getSavedValue("customer[email]");
  document.getElementsByName("customer[password]")[0].value= getSavedValue("customer[password]");
  document.getElementsByName("customer[accepts_marketing]")[0].value= getSavedValue("customer[accepts_marketing]");
  document.getElementsByName("customer[note][date_of_birth]")[0].value= getSavedValue("customer[note][date_of_birth]");
  
  function saveValue(e){
      var id = e.name;  
      var val = e.value; 
      localStorage.setItem(id, val);
  }
  
  function getSavedValue  (v){
      if (!localStorage.getItem(v)) {
          return "";
      }
      return localStorage.getItem(v);
  }

  $('main').prepend(
    '<div id="MOLoginModal" class="mo-modal" style="margin-top: 60px; display: none; /* Hidden by default */ position:relative; /* Stay in place */ z-index:0;/* Sit on top */ padding-top:0%;/* Location of the box */ left: 0;	top:10;/* Full width */ /* Full height */	overflow: hidden; /* Enable scroll if needed */ /* Fallback color */ /* Black w/ opacity */	opacity:1; margin-bottom :50px; padding:1rem; " onload="OTPInput();">' +

    '<div class="mo-modal-content" style="">' +
    '<p id="MOheading" style="display:inline-block;">Verify your email</p><br><br>' +
    '<p style="display:none;" id="otpText">Enter OTP sent to your Email.</p>' +
    '<div id="input-code" style="margin-top: 30px;padding: 10px;display: flex; margin: auto; justify-content: space-evenly; ">' +
    '<input type="text" id="otpinput1" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '<input type="text" id="otpinput2" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '<input type="text" id="otpinput3" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '<input type="text" id="otpinput4" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '<input type="text" id="otpinput5" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '<input type="text" id="otpinput6" class="passInput" style="display:none;" maxlength="1" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" required>' +
    '</div>' +
    '<label id="mobileError" style="display:inline-block;"></label>' +
    '<button id="moAccountCreate" class="btn" style="display:none; -webkit-appearance: button; cursor: pointer;">Verify</button><br>' +
    '<div style="margin-top: 18px;display:none;" id="emailResendButton"><p style="text-align: left; margin-left:9%;">Didn\'t receive the email?</p><p style="text-align: left; margin-left:9%;">Check your spam or <a href="#" style="color: #0071e3;">resend OTP</a></p></div>' +
    '<div style = "margin:auto;">'+
    '</div>'+
    '</div>' +
    '</div>');

  	var styles = '.mo-modal-content {' +
		'margin: auto; padding:5px; border: 1px solid #888; width: 40%; text-align:center;border: none; }' +
		'html {-ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%}' +
		'body {line-height: 1.1; color: #333; background-color: #fff;}' +
		'.iti {width : 80%;}' +
		'.iti__selected-dial-code {font-size: 14px ;     background-color: transparent }'+
		'div[class^="iti__flag"] { display: inline-block ;}' +
		'.passInput{text-align: center;line-height: 8px;padding: 0 !important;font-size: 20px;height: 39px;width: 8%;border-radius: 7px; border: 2px solid black; margin-bottom: 5px;}' +
		'#MOheading{color:#0d0d0d; text-align: center; font-weight: 600; font-size: 40px; width :60% ;margin : 0 0 15px}' +
		'#mobileError{color: #FF0000;font-size: 14px; letter-spacing:1px ; width : 80% ;}' +
		'#moAccountCreate{cursor: pointer;  width: 30%;  background-color: #0071e3; border-radius: 20px; color:white;  margin-top: 0px; margin-bottom: 20px; text-align: center; font-size:14px;border: 1px solid #a5a5a5; height:4rem;}' +
		'#emailResendButton{font-size: 16px;}' +
		'#otpText{ text-align:left; margin-left: 9%; font-size: 16px; margin-bottom: 20px; }' +
		'.mo_label_name{text-align: left;margin-left: 13%;color: #131212;font-weight: 600;font-family: sans-serif;font-size: 18px;}'+
		'.mo_input_firstname{display: inline-block;background-color: #f5f4f4;color: #0d0d0d;padding: 18px 36px;text-align: center;font-size: 14px;margin: 5px;width: 45%;float: left;border: 2px solid #f6f6f6;}'+
		'.mo_input_lastname{display: inline-block;background-color: #f5f4f4;color: #0d0d0d;padding: 18px 36px;text-align: center;font-size: 14px;margin: 5px;width: 45%;border: 2px solid #f6f6f6;}'+
		'.mo_input_label{text-align: center;color: #131212;font-weight: 600;font-family: sans-serif;font-size: 18px;}'+
		'.mo_input_update{display: inline-block;background-color: #f5f4f4;color: #0d0d0d;padding: 18px 36px;text-align: center;font-size: 14px;margin: 5px;width: 100%;border: 2px solid #f6f6f6;}'+
		'.mo_update_btn{cursor: pointer;border: 1px solid transparent;background-color: #f16c13;text-align=center: ;border-radius: 5px 5px 5px 5px;color: white;font-size: 17px;padding: 13px 60px;width: 100%;}'+
		'#MOLoginModal{' +
		' padding-top: 8%; opacity:1}' +
		// '@media (max-width : 50%){ #MOLoginModal .mo-modal-content {' +
		// 'box-shadow: 2px 2px 6px 2px; margin: auto; padding: 20px; margin-bottom:50px;border: 1px solid #888; width: 92%; text-align:center;' +
		// '}'+
		// '}'+
		'@media (max-width : 800px){ .mo-modal-content {' +
		'width:90%; font-size:25px;' +
		'}' +
        '#MOheading {' +
        'width:90%;' +
        '}' +
		'}' +
		'#updateModal{' +
		' padding-top: 8%; opacity:1}' +
		'@media (max-width : 420px){ #updateModal .mo-modal-content {' +
		'background-color: rgba(0,0,0,0.4) box-shadow: 2px 2px 6px 2px; margin: auto; padding: 20px; border: 1px solid #888; width: 92%; text-align:center;' +
		'}' +

		'.close {color: #aaaaaa; float: right; position: relative; top: -16px; font-size: 28px; font-weight: bold;}' +

		'.close:hover,' +
		'.close:focus { color: #000; text-decoration: none; cursor: pointer; }' +
		'.mo-modal { display: none; /* Hidden by default */ position: relative; /* Stay in place */ z-index: 999; /* Sit on top */ padding-top: 5%; /* Location of the box */ left: 0;	top: 0;	width: 100%; /* Full width */ height: 100%; /* Full height */	overflow: auto; /* Enable scroll if needed */  /* Fallback color */  /* Black w/ opacity */	opacity:1; }';


	var styleSheet = document.createElement("style");
	styleSheet.type = "text/css";
	styleSheet.innerText = styles;
	document.head.appendChild(styleSheet);
  
  var createCustomerInputs = document.querySelectorAll(`#${formId} input`);
  for (var i = 0; i < createCustomerInputs.length; i++) {
    createCustomerInputs[i].onkeyup = function () {
      saveValue(this);
    };
  }
  
  var appBaseUrl = "https://store.xecurify.com";
  var flagfield;

  var viewportMeta = document.createElement("meta");
  viewportMeta.name = "viewport";
  viewportMeta.content = "width=device-width, initial-scale=1";
  document.querySelector("head").appendChild(viewportMeta);
  var verifyOtpsForm = document.createElement("form");
  verifyOtpsForm.id = "verifyotps";
  verifyOtpsForm.action =
    appBaseUrl + "/moas/rest/shopify/api/auth/register/verifyOtp2fa";
  verifyOtpsForm.method = "GET";

  const head = document.getElementsByTagName("head")[0];
  const form = document.createElement("form");
  form.setAttribute("id", "verifyotps");
  form.setAttribute(
    "action",
    appBaseUrl + "/moas/rest/shopify/api/auth/register/verifyOtp2fa"
  );
  form.setAttribute("method", "GET");
  form.innerHTML =
    '<input type="text" id="txid" name="txid">' +
    '<input type="text" id="otp" name="otp">' +
    '<input type="text" id="shop" name="shop">' +
    '<input type="text" id="shopcheckouturl" name="shopcheckouturl">' +
    '<input type="text" id="first_name" name="first_name">' +
    '<input type="text" id="last_name" name="last_name">' +
    '<input type="text" id="email" name="email">' +
    '<input type="text" id="password" name="password">' +
    '<input type="text" id="customer_notes" name="customer_notes">' +
    '<input type="text" id="email_subscription" name="email_subscription">';
  head.appendChild(form);
  var Hash_String = window.location.search;
  var CheckoutUrl = "/account";
  const Hash_Param = new URLSearchParams(Hash_String);
  if (Hash_Param.has("checkout_url"))
    CheckoutUrl = decodeURIComponent(Hash_Param.get("checkout_url"));
  var styles = "";
  let accountCreateHandleMo = document.getElementById("moAccountCreate");
  let registerOTPHandleMo = document.getElementById("registerOTP");
  let otpHandleMo = document.getElementById("OTPval");
  let mobileErrorHandlersMo = document.getElementById("mobileErrors");
  var txId;

  var phoneNumber;
  var contact;
  var email;
  var otpvalue;
  var flag = document.createElement("style");

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

	let otpTextHandle = document.getElementById('otpText');
	let otp1Handle = document.getElementById('otpinput1');
	let otp2Handle = document.getElementById('otpinput2');
	let otp3Handle = document.getElementById('otpinput3');
	let otp4Handle = document.getElementById('otpinput4');
	let otp5Handle = document.getElementById('otpinput5');
	let otp6Handle = document.getElementById('otpinput6');
	let mobileErrorHandler = document.getElementById("mobileError");
	let verifyButtonHandle = document.getElementById('moAccountCreate');
	var txId;
	let emailResendButtonHandle = document.getElementById('emailResendButton');
	var phoneNumber;
	var contact;
	var flag = document.createElement('style');
  
  registerOTPHandleMo.addEventListener("click", function (event) {
    event.preventDefault();
    email = document.getElementById('RegisterForm-email').value;
    if (
      document.getElementsByName("customer[first_name]")[0].value == "" ||
      document.getElementsByName("customer[last_name]")[0].value == "" ||
      document.getElementsByName("customer[email]")[0].value == "" ||
      document.getElementsByName("customer[password]")[0].value == "" ||
      document.getElementsByName("customer[note][date_of_birth]")[0].value == ""
    ) {
      mobileErrorHandlersMo.innerHTML =
        "Please enter first name, last name, date of birth, valid email and password to continue...";
    } else if (isValidEmail(email)) {
      mobileErrorHandlersMo.innerHTML =
        "Please wait. We are sending the OTP to your email address";
      var xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        appBaseUrl +
          "/moas/rest/shopify/api/auth/otprequest2fa?shop=" +
          window.location.hostname +
          "&to=" +
          email +
          "&method=create_customer"
          + "&email=" + email);
      xhr.setRequestHeader("Customer-Key", "19682");
      xhr.setRequestHeader("Timestamp", "1611582714234");
      xhr.setRequestHeader(
        "Authorization",
        "f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db"
      );
      xhr.onload = function () {
        if (xhr.status === 200) {
          var result = JSON.parse(xhr.responseText);
          if (result.status == "SUCCESS") {
            document.querySelector('.customer').style.display = 'none';
            document.getElementById("MOLoginModal").style.display = "block";

            mobileErrorHandler.innerHTML = "A one-time password (OTP) has been sent. Please enter within 5 minutes.";
            mobileErrorHandler.style = "margin-bottom: 15px; color: black; display: inline-block;"
            otpTextHandle.style = 'display:block;'
            otpTextHandle.innerHTML = 'Confirm your email address with the email we sent to: <strong>' + email + '</strong> (sent via no-reply@xecurify.com, our official email authenticator)';

            otp1Handle.style = 'display:inline-block;'

            otp2Handle.style = 'display:inline-block;'

            otp3Handle.style = 'display:inline-block;'

            otp4Handle.style = 'display:inline-block;'

            otp5Handle.style = 'display:inline-block;'

            otp6Handle.style = 'display:inline-block;'
            var otpDigitsNumber = "6";
            if( otpDigitsNumber == "4"){
              $('#otpinput5').hide();
              $('#otpinput6').hide();
            }

            verifyButtonHandle.style = 'display:inline-block;'

            emailResendButtonHandle.style = 'display:block;'

            txId = result.txId;
            
          } else if (result.status == "false") {

            if(result.error_code == "Email already registered") {
              mobileErrorHandlersMo.innerHTML = 'Email entered is invalid or already Registered';
            }
            else if(result.error_code == "Phone has already been taken") {
              mobileErrorHandlersMo.innerHTML = 'Mobile Number entered is invalid or already Registered';
            }
            else{
              mobileErrorHandlersMo.innerHTML =
              "Mobile Number entered in invalid or already Registered";
            } 
          }
        } else {
          console.error("Request failed.  Returned status of", xhr.status);
        }
      };
      xhr.send();
    } else {
      mobileErrorHandlersMo.innerHTML = "Invalid email address.";
    }
  });
  
  document.getElementById("moAccountCreate").addEventListener("click", function () {
      otpvalue = $("#otpinput1,#otpinput2,#otpinput3,#otpinput4,#otpinput5,#otpinput6").map(function () { return this.value; }).get().join('');
      // contact = document.getElementById('RegisterForm-email').value;
      var dateOfBirth = document.getElementById('RegisterForm-date_of_birth').value;
      var customerNotes = "date_of_birth: " + dateOfBirth;
      if (
        document.getElementsByName("customer[password]")[0].value == "" ||
        document.getElementsByName("customer[email]")[0].value == "" ||
        otpvalue.length < 4
      ) {
        mobileErrorHandlersMo.innerHTML =
          "Please enter valid OTP , email or password to continue.";
      } else {
        document.getElementById("verifyotps").elements.namedItem("txid").value =
          txId;
        document.getElementById("verifyotps").elements.namedItem("shop").value =
          window.location.hostname;
        document.getElementById("verifyotps").elements.namedItem("otp").value =
          otpvalue;
        document
          .getElementById("verifyotps")
          .elements.namedItem("shopcheckouturl").value = CheckoutUrl;
        document
          .getElementById("verifyotps")
          .elements.namedItem("first_name").value = document.getElementsByName(
          "customer[first_name]"
        )[0].value;
        document
          .getElementById("verifyotps")
          .elements.namedItem("last_name").value = document.getElementsByName(
          "customer[last_name]"
        )[0].value;
        document
          .getElementById("verifyotps")
          .elements.namedItem("email").value =
          document.getElementsByName("customer[email]")[0].value;
        document
          .getElementById("verifyotps")
          .elements.namedItem("password").value =
          document.getElementsByName("customer[password]")[0].value;
        document
          .getElementById("verifyotps")
          .elements.namedItem("customer_notes").value = customerNotes;
        document
          .getElementById("verifyotps")
          .elements.namedItem("email_subscription").value =
          document.querySelector('input[type="checkbox"][name="customer[accepts_marketing]"]').checked ? true : false;
        document.getElementById("verifyotps").submit();
      }
    });

  emailResendButtonHandle.addEventListener('click', function () {
        document.querySelectorAll('.passInput').forEach((input, index, inputs) => {
            input.addEventListener('input', () => {
              if (input.value.length === 1 && index < inputs.length - 1) {
                inputs[index + 1].focus();
              }
            });
          
            input.addEventListener('keydown', (event) => {
              if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
                inputs[index - 1].focus();
              }
            });
        });
  		email =  document.getElementById('RegisterForm-email').value;
        if(email == "" && Hash_Param.has('mobilenumber')){
         email = Hash_Param.get('mobilenumber').replace(/#/g, '');
        }		mobileErrorHandler.innerHTML = "Please Wait. We are sending the OTP again.";
       $.ajax(
			{
				url: appBaseUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&to=" + email + "&action=register",
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {
					if (result.status == 'SUCCESS') {
                      document.querySelector('.customer').style.display = 'none';
                      document.getElementById("MOLoginModal").style.display = "block";
          
                      mobileErrorHandler.innerHTML = "";
                      otpTextHandle.style = 'display:block;'
                      otpTextHandle.innerHTML = 'Confirm your email address with the email we sent to: <strong>' + email + '</strong> (sent via no-reply@xecurify.com, our official email authenticator)';
          
                      otp1Handle.style = 'display:inline-block;'
          
                      otp2Handle.style = 'display:inline-block;'
          
                      otp3Handle.style = 'display:inline-block;'
          
                      otp4Handle.style = 'display:inline-block;'
          
                      otp5Handle.style = 'display:inline-block;'
          
                      otp6Handle.style = 'display:inline-block;'
                      var otpDigitsNumber = "6";
                      if( otpDigitsNumber == "4"){
                        $('#otpinput5').hide();
                        $('#otpinput6').hide();
                      }
          
                      verifyButtonHandle.style = 'display:inline-block;'
          
                      emailResendButtonHandle.style = 'display:block;'
          
                      txId = result.txId;

					}
					else if (result.status == "false") {

                      if(result.error_code == "Email already registered") {
                        mobileErrorHandlersMo.innerHTML = 'Email entered is invalid or already Registered';
                      }
                      else if(result.error_code == "Phone has already been taken") {
                        mobileErrorHandlersMo.innerHTML = 'Mobile Number entered is invalid or already Registered';
                      }
                      else{
                        mobileErrorHandlersMo.innerHTML =
                        "Mobile Number entered in invalid or already Registered";
                      } 
                  }
				},
				error: function (xhr, status, p3, p4) {
                    mobileErrorHandlersMo.innerHTML = "Invalid Email Address.";

				}
			}
		);
	});
  
  if (Hash_Param.has("txid")) {
    document.querySelectorAll('.passInput').forEach((input, index, inputs) => {
        input.addEventListener('input', () => {
          if (input.value.length === 1 && index < inputs.length - 1) {
            inputs[index + 1].focus();
          }
        });
      
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
            inputs[index - 1].focus();
          }
        });
    });
    
    document.querySelector('.customer').style.display = 'none';
    document.getElementById("MOLoginModal").style.display = "block";

    mobileErrorHandler.innerHTML = "";
    otpTextHandle.style = 'display:block;'
    email = document.getElementById('RegisterForm-email').value;
    otpTextHandle.innerHTML = 'Confirm your email address with the email we sent to: <strong>' + email + '</strong> (sent via no-reply@xecurify.com, our official email authenticator)';

    otp1Handle.style = 'display:inline-block;'

    otp2Handle.style = 'display:inline-block;'

    otp3Handle.style = 'display:inline-block;'

    otp4Handle.style = 'display:inline-block;'

    otp5Handle.style = 'display:inline-block;'

    otp6Handle.style = 'display:inline-block;'
    var otpDigitsNumber = "6";
    if( otpDigitsNumber == "4"){
      $('#otpinput5').hide();
      $('#otpinput6').hide();
    }

    verifyButtonHandle.style = 'display:inline-block;'

    emailResendButtonHandle.style = 'display:block;'

    txId = Hash_Param.get("txid");
    
    mobileErrorHandler.innerHTML =
      "You have entered invalid OTP. Please enter valid OTP to create an account";

    mobileErrorHandler.style = "margin-bottom: 15px; display:inline-block;";

    registerOTPHandleMo.value = "Resend";

    otpHandleMo.style =
      'display:inline-block;text-align: center !important;padding: 21px !important;padding-left:28px !important"';

    accountCreateHandleMo.style = "display:inline-block; width:100%";

    accountCreateHandleMo.disabled = false;

    txId = Hash_Param.get("txid");
  }
  
  var styles =
    ".iti__selected-flag{background:none !important}" +
    ".registerOTP{margin: -1px;}" +
    "#OTPval::placeholder {color: initial !important;opacity: 1 !important;}";
  var styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);

  document.querySelectorAll('.passInput').forEach((input, index, inputs) => {
    input.addEventListener('input', () => {
      if (input.value.length === 1 && index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    });
  
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
        inputs[index - 1].focus();
      }
    });
  });
  
});
